<template>
  <div class="my">
    <fixed-header :notShowBack="notShowBack" title="个人中心"></fixed-header>
    <div class="my__main scroll-touch" mg-stat-mod="haowu_my">
      <span v-if="showInfo" class="my__main-logout" mg-stat-click mg-stat-custom="cont=退出账号&label=li&direct=web"
            @click="logout">退出登录</span>
      <div v-if="showInfo" class="my__info">
        <img :src="userInfo.headPicL" alt="" class="my__info-img">
        <ul class="my__info-name">
          <li><span class="nickname">{{ userInfo.nickname }}</span><span v-if="userInfo.showVipEntrance==='1'"
                                                                         class="tag">{{
              vipdetail[vipInfo.vipType]
            }}</span>
          </li>
          <li v-if="userInfo.showVipEntrance==='1'" class="vip" mg-stat-click
              mg-stat-custom="cont=会员入口&label=btn&direct=cntp&addr=haowu_member" mg-stat-mod="vip_enter"
              @click="gotoMember()"><img src="../../assets/img/member/member_my_icon.png">商城VIP专享超低价
          </li>
          <!-- <div v-if="userInfo.level>=3"></div> -->
        </ul>
      </div>
      <div class="my__content">
        <section>
          <div>我的订单</div>
          <div mg-stat-click mg-stat-custom="cont=查看全部订单&label=span&direct=web&addr=haowu_order_all"
               @click="gotoOrder('ALL')">
            <span>查看全部订单</span>
            <i class="icon left_arrow"></i>
          </div>
        </section>
        <section>
          <div class="my__content-order" mg-stat-click
               mg-stat-custom="cont=待付款&label=btn&direct=web&addr=haowu_order_waitpay" @click="gotoOrder('WAITPAY')">
            <p>
              <i class="icon my_not_pay"></i>
            </p>
            <p>待付款</p>
            <div v-if="showNum(userInfo.waitPay)" class="my__content-num">{{ userInfo.waitPay }}</div>
          </div>
          <div class="my__content-order" mg-stat-click
               mg-stat-custom="cont=待发货&label=btn&direct=web&addr=haowu_order_waitsend"
               @click="gotoOrder('WAITSEND')">
            <p>
              <i class="icon my_not_send"></i>
            </p>
            <p>待发货</p>
            <div v-if="showNum(userInfo.waitSend)" class="my__content-num">{{ userInfo.waitSend }}</div>
          </div>
          <div class="my__content-order" mg-stat-click
               mg-stat-custom="cont=待收货&label=btn&direct=web&addr=haowu_order_waitreceive"
               @click="gotoOrder('WAITRECEIVE')">
            <p>
              <i class="icon my_car"></i>
            </p>
            <p>待收货</p>
            <div v-if="showNum(userInfo.waitReceive)" class="my__content-num">{{ userInfo.waitReceive }}</div>
          </div>
          <div class="my__content-order" mg-stat-click
               mg-stat-custom="cont=待评价&label=btn&direct=web&addr=haowu_order_waitccomment"
               @click="gotoOrder('WAITCCOMMENT')">
            <p>
              <i class="icon my_not_comment"></i>
            </p>
            <p>待评价</p>
            <div v-if="showNum(userInfo.unCommentCount)" class="my__content-num">{{ userInfo.unCommentCount }}</div>
          </div>
          <div class="my__content-order" mg-stat-click
               mg-stat-custom="cont=退款&label=btn&direct=web&addr=haowu_refund_list"
               @click="gotoRefund">
            <p>
              <i class="icon my_refund"></i>
            </p>
            <p>退款</p>
            <div v-if="showNum(userInfo.returnCount)" class="my__content-num-refund">{{ userInfo.returnCount }}</div>
          </div>
        </section>
        <section>
          <div mg-stat-click mg-stat-custom="cont=地址管理&label=btn&direct=web&addr=haowu_address_edit"
               @click="gotoAddress">
            <span>
              <i class="icon my_address"></i>
            </span>
            <span>地址管理</span>
            <span>
              <i class="icon left_arrow"></i>
            </span>
          </div>
          <div mg-stat-click mg-stat-custom="cont=购物车&label=btn&direct=web&addr=haowu_cart" @click="gotoCart">
            <span class="my__content-cart">
              <i class="icon big_cart"></i>
            </span>
            <span>购物车</span>
            <span>
              <i class="icon left_arrow"></i>
            </span>
          </div>
          <div mg-stat-click mg-stat-custom="cont=浏览历史&label=btn&direct=web&addr=haowu_browse_history"
               @click="gotoHistory">
            <span>
              <i class="icon my_history"></i>
            </span>
            <span>浏览历史</span>
            <span>
              <i class="icon left_arrow"></i>
            </span>
          </div>
          <div mg-stat-click mg-stat-custom="cont=我的众筹&label=btn&direct=web&addr=haowu_mineCf" @click="gotoCrowdFund">
            <span>
              <i class="icon my_crowfund"></i>
            </span>
            <span>我的众筹</span>
            <span>
              <i class="icon left_arrow"></i>
            </span>
          </div>
          <div mg-stat-click mg-stat-custom="cont=优惠券&label=btn&direct=web&addr=haowu_coupon" @click="gotoCoupon">
            <span style="position:relative">
              <i class="icon my_coupon"></i>
              <b v-if="couponNum" class="my__content-num-coupon">{{ couponNum }}</b>
            </span>
            <span>优惠券</span>
            <span>
              <i class="icon left_arrow"></i>
            </span>
          </div>
          <div mg-stat-click mg-stat-custom="cont=帮助中心&label=btn&direct=web&addr=haowu_help" @click="gotoHelp">
            <span>
              <i class="icon my_help"></i>
            </span>
            <span>帮助中心</span>
            <span>
              <i class="icon left_arrow"></i>
            </span>
          </div>
        </section>
        <section
            :mg-stat-custom="'cont=联系客服&label=btn&direct=web&addr='  + encodeURIComponent('https://support.mgtv.com/webchat/chat.html?c=1&jId=3&pageName=shopByHaowu') "
            class="my__service" mg-stat-click
            @click="gotoChart">
          <span>
            <i class="icon my_service"></i>
          </span>
          <ul>
            <li>联系客服</li>
            <li><i class="icon left_arrow"></i></li>
          </ul>
        </section>
      </div>
      <!--      <goods-demo :originPage="nowPageObj"></goods-demo>-->
    </div>
    <nav-button></nav-button>
  </div>
</template>

<script>
import FixedHeader from 'components/common/FixedHeader';
// import GoodsDemo from 'components/common/GoodsDemo';
import * as userApi from 'apis/user';
import * as couponApis from 'apis/coupon';
import { getQueryParams } from 'utils';
import Env from 'utils/env';
import { getMgtvUserTicket, h5Logout, judgeLogin } from 'utils/user';
import { beforeRouteChange, initCloseUpload, uploadAccessData, uploadCloseData } from 'utils/uploadData';
import DataStorage from 'utils/dataStore';
import NavButton from 'components/common/NavButton';
import { USER_INFO } from 'constants/dataKeys';
import * as VipApi from 'apis/member';
import { vipdetail } from 'constants/member';

export default {
  components: {
    FixedHeader,
    // GoodsDemo,
    NavButton,
  },
  data() {
    const { showBack } = getQueryParams();
    return {
      Env,
      notShowBack: !showBack,
      nowPageObj: this,
      userInfo: {
        nickname: '',
        headPicL: '',
      },
      hasAnyAction: false, // 是否有操作
      hasRouteChange: false,
      couponNum: 0,
      vipInfo: {},
      vipdetail,
    };
  },
  watch: {
    hasAnyAction: {
      handler(val) {
        DataStorage.setPageVisitiLog(val);
      },
      immediate: true,
    },
  },
  computed: {
    showInfo() {
      return (Env.isMobile || Env.isMgtvApp) && this.userInfo.nickname;
    },
  },
  async created() {
    /* 如果已经登录 则调用接口 */
    const userInfo = getMgtvUserTicket();
    if (userInfo && userInfo.ticket) {
      this.fetchUserInfo();
      this.fetchCouponList();
    }
    uploadAccessData();
  },
  mounted() {
    initCloseUpload();
  },
  beforeRouteLeave(to, from, next) {
    if (!this.hasRouteChange) {
      uploadCloseData();
    }
    next();
  },
  methods: {
    judgeLogin,
    gotoHelp() {
      beforeRouteChange({ path: '/help' }, this);
    },
    gotoChart() {
      if (this.hasLogin()) {
        uploadCloseData();
        window.location.href = 'https://support.mgtv.com/webchat/chat.html?c=1&jId=3&pageName=shopByHaowu';
      }
    },
    async fetchCouponList() {
      try {
        const data = await couponApis.getCouponList();
        if (Array.isArray(data)) {
          this.couponNum = data.filter(f => f.isNew === 1 && f.useStatus === 0).length;
        }
        if (Array.isArray(data)) {
          this.couponList = data;
        }
      } catch (error) {
        this.$toast(`获取优惠券失败：${error.message}`);
      }
    },
    gotoCart() {
      beforeRouteChange({ path: '/cart' }, this);
    },
    showNum(val) {
      return Number(val) > 0;
    },
    logout() {
      this.$message.confirm('确定要退出此账号吗?').then(() => {
        h5Logout();
        setTimeout(() => {
          window.location.reload();
        }, 500);
      });
    },
    async fetchUserInfo() {
      try {
        const data = await userApi.getUserInfo();
        this.userInfo = data;
        console.log('USER_INFO======>', USER_INFO);
        DataStorage.setStorage(USER_INFO, {
          nickname: data.nickname,
          avatar: data.headPicL,
          isVip: data.isVip,
        }, 'localStorage');
        if (Number(data.showVipEntrance)) {
          this.fetchUserVipInfo();
        }
      } catch (error) {
        this.$toast(`${error.message}`);
      }
    },
    async fetchUserVipInfo() {
      const vipInfo = await VipApi.userinfo();
      this.vipInfo = vipInfo;
    },
    /* 判断是否登录 */
    hasLogin() {
      if (!this.userInfo.nickname) {
        this.judgeLogin(() => {
          this.fetchUserInfo();
        });
        return false;
      }
      return true;
    },
    gotoOrder(type) {
      if (this.hasLogin()) {
        beforeRouteChange({ path: '/order/all', query: { type } }, this);
      }
    },
    gotoRefund() {
      if (this.hasLogin()) {
        beforeRouteChange({ path: '/refund/list' }, this);
      }
    },
    gotoMember() {
      if (this.hasLogin()) {
        beforeRouteChange({ path: '/member' }, this);
      }
    },
    async gotoAddress() {
      if (this.hasLogin()) {
        const data = await userApi.getAddressList();
        if (!data.length) {
          beforeRouteChange({ path: '/address/edit', query: { id: 0 } }, this); // 没有地址直接去新增地址
        } else {
          beforeRouteChange({ path: '/address/manage' }, this);
        }
      }
    },
    gotoHistory() {
      if (this.hasLogin()) {
        beforeRouteChange({ path: '/browse_history' }, this);
      }
    },
    gotoCrowdFund() {
      if (this.hasLogin()) {
        beforeRouteChange({ path: '/mineCf' }, this);
      }
    },
    gotoCoupon() {
      if (this.hasLogin()) {
        beforeRouteChange({ path: '/coupon' }, this);
      }
    },
  },
};
</script>

<style lang="scss">
.my {
  height: 100%;
  box-sizing: border-box;

  &__main {
    height: 100%;
    position: relative;
    padding-bottom: 100px;
    box-sizing: border-box;

    &-logout {
      font-size: 20px;
      color: #fff;
      position: absolute;
      right: 18px;
      top: 36px;
    }
  }

  &__info {
    height: 238px;
    background: url("~assets/img/my_bg.png") no-repeat center;
    background-size: contain;
    box-sizing: border-box;
    padding: 52px 0 68px 68px;
    margin-bottom: -52px;
    display: flex;

    &-img {
      margin-right: 42px;
      width: 116px;
      height: 116px;
      border-radius: 50%;
      display: block;
      padding: 4px;
      background: #fff;
    }

    &-name {
      color: #fff;

      li {
        height: 48px;
        line-height: 48px;

        &:first-of-type {
          margin-top: 20px;

          .nickname {
            font-size: 34px;
            font-weight: bold;
            max-width: 300px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          display: inline-flex;

          .tag {
            color: #000;
            width: 125px;
            text-align: center;
            background: url("../../assets/img/member/member_type_bg.png") no-repeat;
            background-size: 120px 34.9px;
            background-position: 2px 5px;
            font-size: 20px;
            margin-left: 10px;
            font-weight: 400;
          }
        }
      }

      li.vip {
        img {
          width: 28px;
          height: 20px;
          margin: 0px 10px;
        }

        font-size: 24px;
        width: 276px;
        background: url("../../assets/img/member/menber_my_bg.png") no-repeat;
        background-size: 100% 100%;

      }

      div {
        width: 160px;
        height: 40px;
        background: url('~assets/img/activity/my_vip.png') no-repeat;
        background-size: cover;
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
      }
    }
  }

  &__content {
    border-radius: 20px;
    background: #fff;
    margin: 30px 30px 30px 30px;
    box-shadow: 0px 5px 15px 0px rgba(177, 177, 177, 0.5);

    section:nth-child(1) {
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px;
      border-bottom: 1px solid rgba(211, 211, 211, 0.5);

      div:first-child {
        font-size: 30px;
        font-weight: 600;
        color: #000;
      }

      div:last-child {
        display: flex;
        align-items: center;
        font-size: 28px;
        color: #9b9b9b;

        i {
          margin-left: 30px;
        }
      }
    }

    section:nth-child(2) {
      padding: 43px 50px 28px 50px;
      border-bottom: 1px solid rgba(211, 211, 211, 0.5);
      display: flex;
      justify-content: space-between;
      font-size: 28px;
      font-weight: 600;
      color: #000000;
      text-align: center;

      p:first-child {
        display: flex;
        justify-content: center;
        height: 52px;
        align-items: center;
        margin-bottom: 26px;
      }
    }

    &-order {
      position: relative;
    }

    &-num {
      position: absolute;
      color: #fff;
      width: 26px;
      height: 26px;
      padding: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: #ff5f00;
      right: 0px;
      top: -15px;
      font-size: 18px;
    }

    &-num-coupon {
      @extend .my__content-num;
      right: -20px;
    }

    &-num-refund {
      @extend .my__content-num;
      right: -10px;
    }

    .coupon-dot {
      width: 12px;
      height: 12px;
      position: absolute;
      border-radius: 50%;
      right: -11px;
      top: -6px;
      background: rgba(255, 95, 0, 1);
    }

    section:nth-child(3) {
      padding: 0 50px;

      div {
        height: 120px;
        display: flex;
        align-items: center;
      }

      font-size: 28px;
      color: #000000;

      span:nth-child(1) {
        width: 42px;
        margin-right: 60px;
      }

      span:nth-child(2) {
        flex: 1;
      }

      span:nth-child(3) {
        width: 15px;
      }
    }
  }

  &__service {
    padding: 0 50px;
    display: flex;
    height: 120px;
    align-items: center;
    font-size: 28px;
    color: #000000;

    span:nth-child(1) {
      width: 42px;
      margin-right: 60px;
    }

    ul {
      flex: 1;
      display: flex;
      justify-content: space-between;

      li {
        &:first-of-type {
          flex: 1;
        }
      }
    }

    li {
      line-height: 33px;
    }

    border-top: 1px solid rgba(211, 211, 211, 0.5);
  }

  &__content-cart {
    margin-left: -4px;
    margin-right: 65px !important;
  }
}
</style>
